import React, { Component } from "react";
import { connect } from "react-redux";
import { imagesArr } from "../../../assets/images";
import { getGameSummaryData } from "../../../store/actions";
import { printToPDFMultiple } from "../../../shared/printReportUtils";
import Select from "react-select";
import Loader from "../../../shared/loader";
import HomeAtBat from "../../../components/Charts/AtBat/AtBat";
import HomeSummaryTable from "../../../components/CommanTable/SummaryTable";
import HomeHitterPlateDiscipline from "../../../components/CommanTable/HitterPlateDiscipline";
import HomeHitterBattedBallTable from "../../../components/CommanTable/HitterBattedBallTable";
import HomeHitterPitchSequencingChart from "../../../components/Charts/pitchSequencingChart";
import HomeHitterCountSequencingChart from "../../../components/Charts/pitchSequencingChart";
import HomeHitterResultSequencingChart from "../../../components/Charts/pitchSequencingChart";

class HomeBatters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabs: "",
      hittersData: [],
      homeHitterSummaryTableData: [],
      homeHitterPlateDisciplineTableData: [],
      homeHitterBattedBallTableData: [],
      homePitchersSequenceChart: [],
      homeCountSequenceChart: [],
      homeResultSequenceChart: [],
      homeAtBatTableData: [],
      homeAtBatSprayChartData: [],
      homeAtBatStrikeChartData: [],
      atBatLength: [],
      isPrinting: false,
      isDownloadImg: false
    };
  }

  componentDidMount() {
    let sorceid = document.location.href.split("/")[4];
    if (sorceid === undefined) window.location.href = "/";
    else this.homePitchersData("", false);
  }

  componentDidUpdate = () => {
    if (this.props.appState.homeHitterfilterFlag) {
      if (this.props.homeHitterFilter[0] !== this.state.hittersData[0]?.value) {
        let sorceid = document.location.href.split("/")[4];
        if (sorceid === undefined) window.location.href = "/";
        else this.homePitchersData("", true);
      }
    }
  }

  // fetch Pitch log data
  homePitchersData = (hitterName, flag) => {
    let data = {
      sourceId: document.location.href.split("/")[4],
      tab: "home_hitters",
      filter: {
        pitcher_name: "",
        batter_name: this.props.appState.homeHitterfilterFlag ? this.props.homeHitterFilter[0] : hitterName ? hitterName : this.props.appState.homeHitterName,
      },
      // printflag: this.props?.isPrint
    };
    // this.props.increment();
    this.props.fetchSummaryData(data, (res) => {
      this.setState({
        homeHitterSummaryTableData: res.data.result.hitter_summary_table_data,
        homeHitterPlateDisciplineTableData: res.data.result.hitter_plate_discipline_table_data,
        homeHitterBattedBallTableData: res.data.result.hitter_batted_balls_data,
        homePitchersSequenceChart: res.data.result.hitter_pitch_sequence_chart_data,
        homeCountSequenceChart: res.data.result.hitter_count_sequencing_chart_data,
        homeResultSequenceChart: res.data.result.hitter_result_sequencing_chart_data,
        homeAtBatTableData: res.data.result.hitter_at_bats_table_data,
        homeAtBatSprayChartData: res.data.result.hitter_spray_chart_data,
        homeAtBatStrikeChartData: res.data.result.hitter_strike_zone_data,
        hitterDefault: this.props.appState.homeHitterfilterFlag ? this.props.homeHitterFilter[0] : hitterName ? hitterName : this.props.appState.homeHitterName
      });

      // set atbats length arrary for mapping
      if (this.state.homeAtBatStrikeChartData.length !== 0 && this.state.homeAtBatTableData.length !== 0 && this.state.homeAtBatSprayChartData.length !== 0) {
        let str = Object.keys(this.state.homeAtBatStrikeChartData);
        let tab = Object.keys(this.state.homeAtBatTableData);
        let spr = Object.keys(this.state.homeAtBatSprayChartData);

        // if (JSON.stringify(str) === JSON.stringify(tab) && JSON.stringify(tab)  === JSON.stringify(spr) && JSON.stringify(str) === JSON.stringify(spr)) {
        this.setState({
          atBatLength: str
        })    
        // }
      }

      // for load hitter's wise data
      let hitterData = this.props.homeHitterFilter;

      let hittersSelectData = [];
      // hittersSelectData.push({ value: "", label: "All Hitters" })
      hitterData.map((data) => {
        hittersSelectData.push({
          value: data,
          label: data,
        });
      });
      this.setState({ hittersData: hittersSelectData });
      // this.props.decrement();
      // if (!this.props.isStopPrint && flag) {
      //   this.props.reduceDataCount();
      // }
    });
  };

  handleCallback = (index) => {
    this.setState({
      tabs: index,
    });
  };

  print = async () => {
    await this.setState({ isPrinting: true })
    await printToPDFMultiple(`homeBatters`, [
      // 'ChartPrintAreaHitter',
      'tablePrintAreaHomeBatter',
      ...this.state.atBatLength
    ]);
    this.setState({ isPrinting: false })
  }

  printAll = async () => {
    this.props.printAll();
    this.props.appState.homeHitterName = this.state.hitterDefault;
  }

  // change hitter wise data
  handleChange = (e) => {
      this.props.appState.homeHitterfilterFlag = false
      this.homePitchersData(e.value, true);
  };

  render() {
    const tabs = this.state.tabs;
    let { atBatLength, hittersData, homeHitterSummaryTableData, homeHitterPlateDisciplineTableData, homeHitterBattedBallTableData, homePitchersSequenceChart, homeCountSequenceChart, homeResultSequenceChart, homeAtBatTableData, homeAtBatSprayChartData, homeAtBatStrikeChartData } = this.state;
    return (
      <>
        {this.state.isPrinting && <Loader />}
        {this.state.isDownloadImg && <Loader text={true} />}
        <section className="pb-0" id="ChartPrintAreaHitter" >
          <div className="container-fluid">
            <div className="common-title withsearch">
              <h2>Home Batters</h2>
              <div className="right-side">
                <div className="serch-box">
                  <Select
                    className="customize-select"
                    classNamePrefix="customize-select"
                    onChange={this.handleChange.bind(this)}
                    options={hittersData}
                    value={hittersData.find((obj) => obj.value === this.state.hitterDefault)}
                  // defaultValue={{
                  //   label: "All Hitters",
                  //   value: "",
                  // }}
                  />
                </div>
                {(!(this.state.isPrinting || this.props.isPrint)) && <div className="dropdown">
                  <span className="printer"><img src={imagesArr.printer} alt="print" /></span>
                  <div className="dropdown-content">
                    <ul>
                      <li onClick={() => this.print()}>Print</li>
                      {/* <li onClick={() => this.printAll()}>Print All</li> */}
                    </ul>
                  </div>
                </div>}
              </div>
            </div>
          </div>

          {/* hitter tables */}
          <div id="tablePrintAreaHomeBatter">
            {(this.state.isPrinting || this.props.isPrint) ? <h3>{this.state.hitterDefault}</h3> : ""}
            <div className="ss-hitter-summary-table">
              <HomeSummaryTable tableData={homeHitterSummaryTableData} />
            </div>
            <div className="ss-hitter-platediscipline-table">
              <HomeHitterPlateDiscipline tableData={homeHitterPlateDisciplineTableData} />
            </div>
            <div className="ss-hitter-battedball-table">
              <HomeHitterBattedBallTable tableData={homeHitterBattedBallTableData} />
            </div>

            {/* sequencuning chart */}
            <div className="container-fluid" id="sequencingChartPrintArea">
              <div className="common-charts">
                <div className={`row ${!(this.state.isPrinting || this.props.isPrint) ? 'singleDiv' : 'breakDiv'}`}>
                  <div className="w-33">
                    <HomeHitterPitchSequencingChart
                      chartData={homePitchersSequenceChart}
                      id="PitchSequencingChartHomeHitter"
                      showTitle={true}
                      increment={this.props.increment}
                      decrement={this.props.decrement}
                      eventName={this.props.eventName}
                      pitcherDefault={this.state.hitterDefault}
                      profilepage={false}
                      isNotDownloadImgLoader={() => this.setState((prevState) => ({ ...prevState, isDownloadImg: false }))}
                      isDownloadImgLoader={() => this.setState((prevState) => ({ ...prevState, isDownloadImg: true }))}
                    />
                  </div>
                  <div className="w-33">
                    <HomeHitterCountSequencingChart
                      chartData={homeCountSequenceChart}
                      title="Count"
                      id="countSequencingChartHomeHitter"
                      showTitle={true}
                      increment={this.props.increment}
                      decrement={this.props.decrement}
                      eventName={this.props.eventName}
                      pitcherDefault={this.state.hitterDefault}
                      profilepage={false}
                      isNotDownloadImgLoader={() => this.setState((prevState) => ({ ...prevState, isDownloadImg: false }))}
                      isDownloadImgLoader={() => this.setState((prevState) => ({ ...prevState, isDownloadImg: true }))}
                    />
                  </div>
                  <div className="w-33">
                    <HomeHitterResultSequencingChart
                      chartData={homeResultSequenceChart}
                      title="Result"
                      id="resultSequencingChartHomeHitter"
                      showTitle={true}
                      increment={this.props.increment}
                      decrement={this.props.decrement}
                      eventName={this.props.eventName}
                      pitcherDefault={this.state.hitterDefault}
                      profilepage={false}
                      isNotDownloadImgLoader={() => this.setState((prevState) => ({ ...prevState, isDownloadImg: false }))}
                      isDownloadImgLoader={() => this.setState((prevState) => ({ ...prevState, isDownloadImg: true }))}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="ss-hitter-atbats-table">
            <h3 className="table-title">AT BATS</h3>
            {atBatLength.length !== 0 ?
              atBatLength.map((i) => {
                return <HomeAtBat
                  index={i}
                  atBatStrikeChartData={homeAtBatStrikeChartData}
                  atBatTableData={homeAtBatTableData}
                  atBatSprayChartData={homeAtBatSprayChartData}
                  isPrinting={this.state.isPrinting}
                  isPrint={this.props.isPrint}
                  type="home"
                  increment={this.props.increment}
                  decrement={this.props.decrement}
                  eventName={this.props.eventName}
                  pitcherDefault={this.state.hitterDefault}
                  profilepage={false}
                  isNotDownloadImgLoader={() => this.setState((prevState) => ({ ...prevState, isDownloadImg: false }))}
                  isDownloadImgLoader={() => this.setState((prevState) => ({ ...prevState, isDownloadImg: true }))}
                />
              }) :
              <div className="container-fluid">
                <div className="common-charts text-center">There's no info yet!</div>
              </div>}
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    teamData: state.teamData,
    appState: state.app
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchSummaryData: (data, next) => dispatch(getGameSummaryData(data, next)),
});
export default connect(mapStateToProps, mapDispatchToProps)(HomeBatters);
